import * as React from 'react';



export default class Note extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="Page-1-Copy-4" transform="translate(2.000000, 1.000000)">
            <polygon id="Fill-1-Copy" className="strokeColor" stroke="currentColor" fill="currentColor" points="9.3128571 14.2722982 10.59375 14.2722982 10.59375 3.75 9.3128571 3.75"></polygon>
            <path d="M10.6815536,3.18583333 L10.6815536,14.0291667 C10.6815536,14.2666667 10.4967321,14.4583333 10.2669107,14.4583333 L0.616017857,14.4583333 C0.386196429,14.4583333 0.201375,14.2666667 0.201375,14.0291667 L0.201375,0.638333333 C0.201375,0.400833333 0.386196429,0.208333333 0.616017857,0.208333333 L7.66976786,0.208333333 C7.77583929,0.208333333 7.87789286,0.250833333 7.95423214,0.325833333 L10.5521786,2.87333333 C10.6349464,2.955 10.6815536,3.0675 10.6815536,3.18583333 Z" id="Stroke-1"></path>
            <path d="M6.79315179,0.2085 L6.79315179,3.121 C6.79315179,3.35266667 6.9755625,3.54016667 7.19895536,3.53766667 L10.6816339,3.53933333" id="Stroke-3"></path>
            <path d="M2.72507143,7.52341667 L7.69676786,7.52341667" id="Stroke-5"></path>
            <path d="M2.72507143,4.19008333 L4.00596429,4.19008333" id="Stroke-7"></path>
            <path d="M2.72507143,10.85675 L7.69676786,10.85675" id="Stroke-9"></path>
        </g>
      </svg>
    )
  }
}
